var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zylc-all-box"},[_c('div',{staticClass:"img-box"},[_c('img',{attrs:{"src":require("@/assets/images/serviceGuide/zylc.png"),"width":"100%","alt":""}})])])
}]

export { render, staticRenderFns }